import axios from "axios";

function normalizeBannersBaseUrl(raw: string | undefined): string {
  return (raw ?? "").trim().replace(/\/+$/, "");
}

export const baseURLBannersAPI = normalizeBannersBaseUrl(
  process.env["REACT_APP_BANNERS_URL_API"],
);

/**
 * Cliente HTTP para a API de banners (marketing).
 * O Bearer JWT deve ser enviado em cada request (token emitido por GET cliente/banners/token na API Conexão).
 */
const banners = axios.create({
  baseURL: baseURLBannersAPI,
});

export default banners;
